


































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ColorSelect from '../colorSelect.vue';
import { cloneDeep } from 'lodash';
import { Form } from '@ss/mtd-vue';
import * as api from '@/api';
import SortOncallMemberModal from './sortOncallMemberModal.vue';

import { OncallRulesTable, WeekDays, OncallCycleTypeMap } from '@/config/map.conf';
import { getCurrentTimezoneOffsetMs } from '@/utils/tool';

const baseTime = getCurrentTimezoneOffsetMs();
const TODAY: number = new Date(new Date().setHours(0, 0, 0, 0)).valueOf();

const validateName: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('规则名称不能为空'));
    }
    if (value.length > 10) {
        return callback(new Error('班次名称不能超过10个字'));
    }
    return callback();
};
const validateMember: Function = (_rule, value, callback) => {
    if (!value || !value.length) {
        return callback(new Error('值班成员不能为空'));
    }
    return callback();
};
@Component({
    components: {
        ColorSelect,
        SortOncallMemberModal
    }
})
export default class AddRuleModal extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop({ default: 'add' })
    type: 'add' | 'update';
    @Prop({ default: 'normal' })
    ruleDateType: 'special' | 'normal';
    @Prop({ default: () => ({}) })
    formData: CommonTypes.mapObject;

    tableList: CommonTypes.mapObject = OncallRulesTable;
    oncallCycleTypes: CommonTypes.mapObject[] = OncallCycleTypeMap;
    weekDays: string[] = WeekDays;

    rules = {
        name: [{ validator: validateName, trigger: 'blur' }],
        formatOncallUser: [{ validator: validateMember, trigger: 'blur' }],
        oncallGroup: [{ validator: validateMember, trigger: 'blur' }]
    };
    $refs: {
        ruleForm: Form;
    };

    colorOptions: CommonTypes.mapObject[] = [];
    ruleData: CommonTypes.mapObject = {};
    selectedOncallMember: CommonTypes.mapObject[] = [];
    ruleDateOptions: CommonTypes.mapObject = {
        disabledDate(date: Date) {
            return date && !((date.getTime() - TODAY) / (1000 * 60 * 60 * 24) > 0 && (date.getTime() - TODAY) / (1000 * 60 * 60 * 24) < 16);
        }
    };

    shiftList: CommonTypes.mapObject[] = [];
    oncallMemberList: CommonTypes.mapObject[] = [];
    oncallGroupList: CommonTypes.mapObject[] = [];

    showModal: boolean = false;
    btnLoading: boolean = false;
    searchLoading: boolean = false;
    showSortModal: boolean = false;

    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
    }
    @Watch('formData', { immediate: true, deep: true })
    onDataChanged() {
        this.ruleData = cloneDeep(this.formData);
        this.ruleData.cycleTime = new Date(this.ruleData.cycleTime - baseTime);
        this.ruleData = {
            ...this.ruleData,
            formatTime: this.getMillisecond(this.ruleData.cycleTime),
            formatOncallUser: this.ruleData.oncallUser?.map(item => `${item.displayName}/${item.identify}`),
            oncallGroup: this.ruleData.oncallGroup?.map(item => `${item.displayName}/${item.identify}`)
        };
    }
    formatSelectWeekDays({ label }) {
        return label;
    }
    created() {
        this.getShifts();
        this.getOncallGroups();
    }
    async getOncallGroups() {
        const res = await api.oncallApi.getRgGroups({
            rgId: this.rgId
        });
        const { data, code } = res;
        if (code === 200 && data) {
            this.oncallGroupList = data.items || [];
        }
    }
    onSorted(list) {
        if (this.ruleData.oncallType === 'BY_USERNAME') {
            this.ruleData.formatOncallUser = [].concat(list);
        } else {
            this.ruleData.oncallGroup = [].concat(list);
        }
    }
    async getShifts() {
        const res = await api.oncallApi.getShifts(this.rgId);
        const { data, code } = res;
        if (code === 200 && data) {
            this.shiftList = data.items || [];
            this.colorOptions = this.shiftList.map(item => {
                return {
                    color: item.color,
                    label: item.abbreviation,
                    selected: this.ruleData.shiftId?.includes(item.id),
                    disabled: false,
                    id: item.id
                };
            });
        }
    }
    getMillisecond(date) {
        if (date) {
            const hour = date.getHours();
            const min = date.getMinutes();
            return (hour * 3600 + min * 60) * 1000;
        } else {
            return 0;
        }
    }
    async searchUser(query?: string) {
        // if (!query || !query.trim()) {
        //     this.oncallMemberList = [];
        //     return;
        // }
        const params = {
            rgId: this.rgId,
            identify: query || ''
        };
        const res = await api.rgApi.getRgUser(params);
        if (res && res.code === 200) {
            this.oncallMemberList = res.data.items;
            this.searchLoading = false;
        }
    }
    confirm() {
        this.$refs.ruleForm
            .validate(valid => {
                if (valid) {
                    this.addOrUpdateRule();
                }
            })
            .catch(e => {
                console.log('error: ', e);
                this.btnLoading = false;
            });
    }
    async addOrUpdateRule() {
        this.btnLoading = true;
        try {
            const requestParam: any = {
                ...this.ruleData,
                rgId: this.rgId,
                ruleDateType: this.ruleDateType.toUpperCase(),
                oncallUser: this.ruleData.formatOncallUser?.map(item => item.split('/')[1]),
                oncallGroup: this.ruleData.oncallGroup?.map(item => item.split('/')[1]) || [],
                cycleDay: this.ruleData.cycleType === 'CUSTOM' ? this.ruleData.cycleDayForCustom : this.ruleData.cycleDay,
                cycleTime: this.ruleData.formatTime,
                ruleStartAt: this.ruleData.ruleAtList[0],
                ruleEndAt: this.ruleData.ruleAtList[1],
                shiftType: this.ruleData.ruleType === 'CYCLICAL_RULE' ? null : this.ruleData.shiftType
            };
            const res = await api.oncallApi[`${this.type}RgRule`](requestParam);
            const { code } = res;
            if (code === 200) {
                this.$mtd.message.success(`${this.type === 'add' ? '添加' : '编辑'}规则成功`);
                this.btnLoading = false;
                this.$emit('success', this.ruleDateType);
                this.close();
            }
        } catch (error) {
            console.log('error: ', error);
            this.btnLoading = false;
        }
    }
    emitTimeChange() {
        this.ruleData.formatTime = this.getMillisecond(this.ruleData.cycleTime);
    }
    onColorChanged(options) {
        this.ruleData.shiftId = options.filter(item => item.selected).map(item => item.id);
    }
    close() {
        this.$emit('update:visible', false);
    }
    get title() {
        return `${this.type === 'add' ? '添加' : '编辑'}${this.ruleDateType === 'special' ? '特定' : '日常'}值班规则`;
    }
    get hint() {
        return this.tableList.find(item => item.key === this.ruleDateType)[this.type === 'add' ? 'modalHint' : 'modalEditHint'];
    }
    get disableShiftBtn() {
        return !this.shiftList.length;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
